/**
 * Created by sivanh on 14/06/2018.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var BaseCollection = require("collections/BaseCollection");

    var ShiftModel = require("models/entities/scheduling/ShiftModel");

    var ShiftsCollection = BaseCollection.extend({
        model: ShiftModel,
        validate : function () {
            var errors = {};

            this.each(function(shiftModel) {
                var modelErrors = shiftModel.validate();
                if (modelErrors) {
                    errors = modelErrors;
                }
            });

            return errors;
        }

    });

    ShiftsCollection.Model = ShiftModel;

    return ShiftsCollection;

});
